import { RouteObject } from 'react-router-dom';
import React from 'react';
import { CspPath } from '../../../CspPath';
import { PathUtil } from '../../navigation/util/PathUtil';

const lazyLoadPages: () => Promise<typeof import('./studyDocumentPages')> = () =>
  import(/* webpackPrefetch: true */ './studyDocumentPages');

const Layout = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.StudyDocumentsLayout,
  })),
);
const FilesPage = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.StudyDocumentsFilesPage,
  })),
);
const TrashPage = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.StudyDocumentsTrashPage,
  })),
);

export const studyDocumentsRoutes: RouteObject[] = [
  {
    element: <Layout />,
    loader: async () => (await lazyLoadPages()).studyDocumentsLayoutPreload(),
    children: [
      {
        path: '',
        element: <FilesPage />,
        loader: async () => (await lazyLoadPages()).studyDocumentsFilesPagePreload(),
      },
      {
        path: PathUtil.toRelativePath(CspPath.STUDY_OVERVIEW_DOCUMENTS, CspPath.STUDY_OVERVIEW_DOCUMENTS_FOLDER, true),
        element: <FilesPage />,
        loader: async ({ params }) => (await lazyLoadPages()).studyDocumentsFilesPagePreload(params['folderId']),
      },
      {
        path: PathUtil.toRelativePath(CspPath.STUDY_OVERVIEW_DOCUMENTS, CspPath.STUDY_OVERVIEW_DOCUMENTS_TRASH, true),
        element: <TrashPage />,
        loader: async () => (await lazyLoadPages()).studyDocumentsTrashPagePreload(),
      },
    ],
  },
];
